/** This method provides minimal math formatting by injecting HTML <sub> ans <sup> tags. */
export function formatMathHTML(str: string): string {
  return ("" + str)
    .replace(/_(?:\{(.*)\}|(.))/g, "<sub>$1$2</sub>") // "P_x0"->"P<sub>x</sub>0", "P_{x0}"->"P<sub>x0</sub>"
    .replace(/\^(?:\{(.*)\}|(.))/g, "<sup>$1$2</sup>"); // "P^23"->"P<sup>2</sup>3", "P^{23}"->"P<sup>2</sup>3"
}
